import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { LeagueItem, RaceDaysTableItem, RacesService } from '../service/races.service';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { forkJoin } from 'rxjs';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import html2canvas from 'html2canvas-pro';


@Component({
    selector: 'app-leageTableV3',
    standalone: true,
    templateUrl: './leagueTableV3.component.html',
    styleUrls: ['./leagueTableV3.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        TableModule,
        RouterModule,
        FormsModule,
        SelectModule,
        ButtonModule
    ],
    providers: [
        RacesService
    ]
})
export class LeagueTableV3 implements OnInit{
    constructor(private racesService: RacesService,private changeDetectorRef: ChangeDetectorRef) {}

    @ViewChild('tableWrapper') tableWrapper!: ElementRef;

    @Input() season: number = 0
    @Input() seasonName: string | null = null;
    @Input() group: number = 0;

    playerList: LeagueItem[] = [];
    dataLoaded = false;
    showAverageColumn = false;

    raceDays: RaceDaysTableItem[] = [];
    raceDaysLoading = true;

    sortOptions = [
        { label: 'Position', value: 'final_position' },
        { label: 'Fahrer', value: 'name_gt7' },
        { label: 'Auto', value: 'car_name' },
        { label: 'Siege', value: 'win_count' },
        { label: 'Top 5', value: 'top5_count' },
        { label: 'Durchschnitt (Ø)', value: 'average_points_v3' }
    ];
    selectedSortField: string = 'final_position';
    sortOrder: number = 1;

    sortDirectionOptions = [
        { label: 'Aufsteigend', value: 1 },
        { label: 'Absteigend', value: -1 }
    ];

    onSortChange() {
        if (this.selectedSortField === 'average_points_v3') {
            this.showAverageColumn = true;
            this.sortOrder = -1;
        } else {
            this.showAverageColumn = false;
        }
    }

    exportPlayerNames() {
        const sorted = [...this.playerList].sort((a, b) => {
            const aVal = (a as any)[this.selectedSortField] ?? '';
            const bVal = (b as any)[this.selectedSortField] ?? '';
            if (aVal < bVal) return -1 * this.sortOrder;
            if (aVal > bVal) return 1 * this.sortOrder;
            return 0;
        });
        const names = sorted.map(p =>
            p.name_gt7 !== p.name_psn ? `${p.name_gt7} (PSN: ${p.name_psn})` : p.name_gt7
        ).join('\n');
        const blob = new Blob([names], { type: 'text/plain' });
        const link = document.createElement('a');
        link.download = `players-season-${this.season}.txt`;
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(link.href);
    }

    exportAsImage() {
        const element = this.tableWrapper.nativeElement;
        // Force all nested elements to have no overflow/scrollbars
        const allChildren = element.querySelectorAll('*');
        const origStyles: { el: HTMLElement; overflow: string; maxWidth: string; width: string }[] = [];
        origStyles.push({ el: element, overflow: element.style.overflow, maxWidth: element.style.maxWidth, width: element.style.width });
        element.style.overflow = 'visible';
        element.style.maxWidth = 'none';
        element.style.width = 'max-content';
        allChildren.forEach((child: Element) => {
            // Only adjust HTML layout containers. SVG icons also default to
            // non-visible overflow, but forcing `width: max-content` on them makes
            // Safari expand each to the 300px SVG default, bloating column widths.
            if (!(child instanceof HTMLElement)) return;
            const computed = window.getComputedStyle(child);
            if (computed.overflow !== 'visible' || computed.overflowX !== 'visible' || computed.overflowY !== 'visible') {
                origStyles.push({ el: child, overflow: child.style.overflow, maxWidth: child.style.maxWidth, width: child.style.width });
                child.style.overflow = 'visible';
                child.style.maxWidth = 'none';
                child.style.width = 'max-content';
            }
        });
        const restore = () => {
            origStyles.forEach(({ el, overflow, maxWidth, width }) => {
                el.style.overflow = overflow;
                el.style.maxWidth = maxWidth;
                el.style.width = width;
            });
        };
        html2canvas(element, { backgroundColor: '#ffffff', scale: 2, useCORS: true }).then(canvas => {
            restore();
            const link = document.createElement('a');
            link.download = `league-table-season-${this.season}.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();
        }).catch(() => {
            restore();
        });
    }

    ngOnInit() {
       this.loadData();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['season']) {
            this.loadData();
        }
    }

    loadData2() {
        this.racesService.getLeagueTableForSeasonV3(String(this.season)).subscribe((player) => {
            this.playerList = player;
            this.sortPlayerList();
            this.changeDetectorRef.detectChanges(); // Trigger change detection
            console.log("leagueTable - getLeagueTableForSeason");
            console.log(this.playerList);
        });
        this.racesService.getTotalPointsForSeasonV3(String(this.season)).subscribe((data) => {
            console.log("leagueTable - getTotalPointsForSeasonV3");
            console.log(data);
            // Map total points to playerList
            data.forEach((item: any) => {
                const player = this.playerList.find(p => p.player_id === item.player_id);
                if (player) {
                    player.average_points_v3 = item.average_points_v3;
                }
            });
            this.changeDetectorRef.detectChanges(); // Trigger change detection
        });
    }

    loadData() {
        this.dataLoaded = false;
        forkJoin({
            player: this.racesService.getLeagueTableForSeasonV3(String(this.season)),
            totalPoints: this.racesService.getTotalPointsForSeasonV3(String(this.season))
        }).subscribe(({ player, totalPoints }) => {
            this.playerList = player;
            this.sortPlayerList();
            // Map total points to playerList
            totalPoints.forEach((item: any) => {
                const player = this.playerList.find(p => p.player_id === item.player_id);
                if (player) {
                    player.average_points_v3 = item.average_points_v3;
                }
            });
            this.dataLoaded = true;
            this.computeWinCounts();
            this.computeTop5Counts();
            this.changeDetectorRef.detectChanges(); // Trigger change detection
        });
    }

    sortPlayerList() {
        this.playerList.sort((a, b) => {
            // Example: Sort by position_finished in ascending order
            return (a.final_position ?? 0) - (b.final_position ?? 0);
        });
    }

    hasDayRacePoints(player_id: number, raceday: string): boolean{
        const player = this.playerList.find(p => p.player_id === player_id);
        if (player && player.races) {
            return player.races.some(race => race.day_id === raceday);
        }
        return false;
    }


    getDayRacePoints(player_id: number, raceday: string){
        const player = this.playerList.find(p => p.player_id === player_id);
        if (player && player.races) {
            const race = player.races.find(race => race.day_id === raceday);
            return race ? race.points_v1 : null;
        }
        return null;
    }

    getPodiumClass(player: any): string {
        if (player.final_position === 1) return 'podium-gold';
        if (player.final_position === 2) return 'podium-silver';
        if (player.final_position === 3) return 'podium-bronze';
        return '';
    }

    computeWinCounts() {
        // Collect all unique race day IDs
        const dayIds = new Set<string>();
        this.playerList.forEach(p => p.races?.forEach(r => dayIds.add(r.day_id)));

        // For each day, find the max points and who achieved it
        const winCounts = new Map<number, number>();
        dayIds.forEach(dayId => {
            let maxPoints = -1;
            let winners: number[] = [];
            this.playerList.forEach(p => {
                const race = p.races?.find(r => r.day_id === dayId);
                if (race && race.points_v3 !== undefined) {
                    if (race.points_v3 > maxPoints) {
                        maxPoints = race.points_v3;
                        winners = [p.player_id!];
                    } else if (race.points_v3 === maxPoints) {
                        winners.push(p.player_id!);
                    }
                }
            });
            winners.forEach(id => winCounts.set(id, (winCounts.get(id) ?? 0) + 1));
        });

        // Assign win_count to each player
        this.playerList.forEach(p => {
            (p as any).win_count = winCounts.get(p.player_id!) ?? 0;
        });
    }

    computeTop5Counts() {
        const dayIds = new Set<string>();
        this.playerList.forEach(p => p.races?.forEach(r => dayIds.add(r.day_id)));

        const top5Counts = new Map<number, number>();
        dayIds.forEach(dayId => {
            const results: { playerId: number; points: number }[] = [];
            this.playerList.forEach(p => {
                const race = p.races?.find(r => r.day_id === dayId);
                if (race && race.points_v3 !== undefined) {
                    results.push({ playerId: p.player_id!, points: race.points_v3 });
                }
            });
            results.sort((a, b) => b.points - a.points);
            results.slice(0, 5).forEach(r => {
                top5Counts.set(r.playerId, (top5Counts.get(r.playerId) ?? 0) + 1);
            });
        });

        this.playerList.forEach(p => {
            (p as any).top5_count = top5Counts.get(p.player_id!) ?? 0;
        });
    }

    getHeaderColspan(): number {
        let cols = 4; // position, driver, total, wins
        //if (this.showIndexColumn) cols++;
        cols++; // top5
        cols += this.raceDays.length;
        if (this.showAverageColumn) {
            cols = cols + 2; 
        } 
        return cols;
    }
}
